import { Link } from "react-router-dom";
import { BookOpen, MessageCircle, Brain, Calculator, Users, Heart, Wind, Ear } from "lucide-react";

/**
 * Bloc "Que voulez-vous travailler ?" pour la home.
 * Vignettes rapides menant vers /recherche?q=... avec mot-clé pertinent.
 */
const QUICK_NEEDS = [
  { title: "Lecture / Dyslexie", icon: BookOpen, color: "from-rose-500 to-pink-600", q: "dyslexie lecture" },
  { title: "Articulation / Phonologie", icon: MessageCircle, color: "from-orange-500 to-amber-600", q: "articulation phonologie" },
  { title: "Mémoire / Attention", icon: Brain, color: "from-indigo-500 to-purple-600", q: "mémoire attention TDAH" },
  { title: "Logico-mathématique", icon: Calculator, color: "from-emerald-500 to-teal-600", q: "logico-mathématique" },
  { title: "Communication", icon: Users, color: "from-sky-500 to-blue-600", q: "communication langage oral" },
  { title: "Émotions / Social", icon: Heart, color: "from-fuchsia-500 to-rose-600", q: "émotions" },
  { title: "Oro-motricité / Souffle", icon: Wind, color: "from-cyan-500 to-sky-600", q: "praxies souffle" },
  { title: "Perception auditive", icon: Ear, color: "from-violet-500 to-indigo-600", q: "auditif" },
];

export default function NeedsBlock() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-16" data-testid="needs-block">
      <div className="mb-8 sm:mb-10 max-w-2xl">
        <p className="text-xs uppercase tracking-[0.25em] text-ink/60 mb-3">Orthophonie clinique</p>
        <h2 className="font-display text-2xl sm:text-3xl md:text-4xl text-pedablue">
          Que voulez-vous travailler ?
        </h2>
        <p className="mt-2 text-sm sm:text-base text-ink-soft">
          Choisissez un domaine — vous verrez immédiatement les outils adaptés à votre séance.
        </p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4">
        {QUICK_NEEDS.map((n) => {
          const Icon = n.icon;
          return (
            <Link
              key={n.q}
              to={`/recherche?q=${encodeURIComponent(n.q)}`}
              data-testid={`quick-need-${n.q.split(" ")[0]}`}
              className="group bg-white rounded-2xl border border-ink/10 p-4 sm:p-5 hover:shadow-md hover:-translate-y-0.5 transition-all text-center sm:text-left"
            >
              <div className={`w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-gradient-to-br ${n.color} flex items-center justify-center text-white mx-auto sm:mx-0 mb-3 group-hover:scale-110 transition-transform`}>
                <Icon size={20} strokeWidth={2} />
              </div>
              <h3 className="text-sm sm:text-base font-medium text-pedablue leading-snug">{n.title}</h3>
            </Link>
          );
        })}
      </div>
      <div className="text-center mt-6">
        <Link to="/par-besoin" className="text-sm text-pedablue hover:underline">Voir tous les domaines →</Link>
      </div>
    </section>
  );
}
